import { useMutation, useQueryClient } from '@tanstack/react-query';
import { bulkLinkConfigOption } from '../services/smr-admin';
import { configOptionKeys } from './useConfigOptionsQuery';

export function useBulkLinkConfigOptionMutation(optionId: string | undefined) {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (opts: { force?: boolean } = {}) =>
            bulkLinkConfigOption(optionId!, opts),
        onSuccess: () => {
            if (optionId) qc.invalidateQueries({ queryKey: configOptionKeys.detail(optionId) });
        },
    });
}
